<div>
	<my-col-dropdownlist [required]="true" [parent]="component" [key]="'Dieta'" #Dieta [labelVisible]="true" [labelName]="'Dieta'"></my-col-dropdownlist>

	<div class="ml-3 mr-3 pl-3 mt-5 row">
		<my-group-save-buttons class="w-100" [saving]="saving" [targetName]="'Dieta'"
							   (onSave)="onDietaSave($event)" (onCancel)="onDietaCancel($event)"></my-group-save-buttons>
	</div>
</div>
